'use client'

import { Auth0Provider } from '@auth0/nextjs-auth0'
import { TaloErrorBoundary } from '~/components/TaloErrorBoundary'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactNode, useState } from 'react'
import { Provider as JotaiProvider } from 'jotai'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// import { Frigade } from '~/components/Frigade'
import { globalStore } from '~/store'
import { DashboardWorkspaceContextProvider } from './(dashboard)/dashboardContext'

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <TaloErrorBoundary>
      <Auth0Provider>
        <JotaiProvider store={globalStore}>
          {/* <Frigade> */}
          <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
            <DashboardWorkspaceContextProvider>
              {children}
            </DashboardWorkspaceContextProvider>
          </QueryClientProvider>
          {/* </Frigade> */}
        </JotaiProvider>
      </Auth0Provider>
    </TaloErrorBoundary>
  )
}
